import React, { useEffect, useState } from 'react';
import { GlassTypesManager } from './GlassTypesManager';
import { GlassTypesProvider, useGlassTypes } from '@/contexts/GlassTypesContext';
import { GLASS_TYPE_CATEGORIES } from '@/utils/glassTypeLoader';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '@/components/ui/select';
import { Database, FolderOpen } from 'lucide-react';

const GlassTypesTabContent: React.FC = () => {
  const { 
    setSelectedSource, 
    clearGlassTypes, 
    selectedSource, 
    enabledTypes,
    isLoading,
    availableGroups,
    selectedGroup,
    setSelectedGroup
  } = useGlassTypes();
  
  const [initialized, setInitialized] = useState(false);

  // Clear any cached information when the component mounts
  useEffect(() => {
    if (initialized) return;
    
    // Clear the glass types array to remove any cached data
    clearGlassTypes();

    // Set CLG as the default source if no source is selected
    if (!selectedSource || selectedSource === 'default') {
      console.log('Setting default source to CLG');
      // Use setTimeout to ensure this happens after the initial render cycle
      setTimeout(() => {
        setSelectedSource('CLG');
      }, 0);
    }

    // Log the current state for debugging
    console.log('GlassTypesTab initialized with:', {
      selectedSource,
      enabledTypesCount: enabledTypes.length,
      enabledTypes,
      availableCategories: GLASS_TYPE_CATEGORIES
    });
    
    setInitialized(true);
  }, [selectedSource, enabledTypes, clearGlassTypes, setSelectedSource, initialized]);

  return (
    <div>
      {isLoading ? (
        <div className="flex justify-center items-center h-32">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          <span className="ml-2 text-blue-500">Loading glass types...</span>
        </div>
      ) : (
        <GlassTypesManager />
      )}
    </div>
  );
};

const GlassTypesTab: React.FC = () => {
  return (
    <GlassTypesProvider>
      <GlassTypesTabContent />
    </GlassTypesProvider>
  );
};

export default GlassTypesTab;
